import createPage from "@src/components/page"
import React from "react"
import d1Img from "@images/png/23.png"
import d2Img from "@images/png/24.png"
import * as styles from "./pageEnd.module.scss"
import { cdnUrl, pageUrl, redColor } from "@config"
import { animated } from "react-spring"
import { useEnteringTrail } from "@src/components/page/lib"
import Button from "@src/components/button"
import { useContext } from "react"
import PagesContext from "@src/context/pagesContext"

import wallpaperImg from "@images/wallpaper.jpg"
import { platformCheck, postAppMsg, postMsg } from "@src/utils/request"
import AppContext from "@src/context/appContext"
import bgImg from "@images/2022/p13/52-100.jpg"
import heImg from "@images/2022/p13/54.png"
import btnRewindImg from "@images/2022/new/13aa.png"
import btnCheckImg from "@images/2022/new/19aa.png"
import btnDiscussImg from "@images/2022/p13/55.png"
import btnDownloadImg from "@images/2022/p13/56.png"
import starImg from "@images/2022/p13/57.png"
import handImg from "@images/2022/new/14aa.png"
import Clickable from "@src/components/clickable"

const wallpaperUrl = `${cdnUrl}${wallpaperImg}`

const totalDuration = 3000
const PageEnd = createPage(
  ({ offset, data: { myself } }) => {
    const { md } = useContext(AppContext)
    const { returnToFirst } = useContext(PagesContext)
    const anime1Styles = useEnteringTrail(2, offset, {
      totalDuration,
      step: 0.1,
    })
    const anime2Styles = useEnteringTrail(6, offset, {
      totalDuration,
      step: 0.4,
    })
    const anime3Styles = useEnteringTrail(1, offset, {
      totalDuration,
      step: 0.8,
    })
    return (
      <>
        <div className={styles.icons}>
          <div className="iconsGroup">
            <div>
              <animated.img
                style={anime1Styles[0]}
                src={heImg}
                className={styles.he}
                alt="icon"
              />
              <animated.img
                style={anime1Styles[1]}
                src={handImg}
                className={styles.hand}
                alt="icon"
              />
            </div>
          </div>
        </div>
        <div className={styles.text}>
          <p>
            <animated.span style={anime2Styles[0]}>
              桔子不是唯一的<span className="nowrap">水果</span>，
              <span className="nowrap">人生最美妙的是走远路</span>
            </animated.span>
          </p>
          <p>
            <animated.span style={anime2Styles[1]}>
              祝所有的机核用户们
            </animated.span>
            <br />
            <animated.span style={anime2Styles[2]}>
              都能拥有健康的身体、<span className="nowrap">有趣的灵魂</span>
              <span className="nowrap">与无尽的快乐</span>
            </animated.span>
            <br />
            <animated.span style={anime2Styles[3]}>
              守护自己、家人、理想与<span className="nowrap">所爱的一切</span>
            </animated.span>
          </p>
          <p>
            <animated.span style={anime2Styles[4]}>
              感谢长久以来你给予机核的<span className="nowrap">信任与陪伴</span>
            </animated.span>
            <br />
            <animated.span style={anime2Styles[5]}>
              2023愿我们能始终同行，<span className="nowrap">守望与共</span>
            </animated.span>
          </p>
        </div>

        <animated.div style={anime3Styles[0]} className={styles.buttons}>
          <Clickable
            onClick={() => {
              returnToFirst()
            }}
          >
            <img src={btnRewindImg} alt="rewind" className={styles.btnRe} />
          </Clickable>
          <Clickable
            onClick={() => {
              if (myself) {
                platformCheck(
                  () => {
                    postAppMsg("navigate", {
                      link: `https://www.gcores.com/topics/372`,
                    })
                  },
                  () => {},
                  { onlyInApp: true }
                )
              } else {
                window.location.href = pageUrl
              }
            }}
          >
            {myself ? (
              <>
                <img src={starImg} alt="icon" className={styles.star} />
                <img src={btnDiscussImg} alt="discuss" className={styles.btn} />
              </>
            ) : (
              <img src={btnCheckImg} alt="check mine" className={styles.btn} />
            )}
          </Clickable>
          <Clickable
            onClick={() => {
              platformCheck(
                () => {
                  if (md?.is("AndroidOS")) {
                    postMsg({
                      action: "download-image",
                      data: {
                        url: wallpaperUrl,
                        fileType: "jpg",
                      },
                    })
                  } else {
                    postAppMsg("share", {
                      image: wallpaperUrl,
                    })
                  }
                },
                () => {
                  window.open(wallpaperUrl, "_blank")
                }
              )
            }}
          >
            <img src={btnDownloadImg} alt="wallpaper" className={styles.btn} />
          </Clickable>
        </animated.div>
      </>
    )
  },
  {
    className: styles.page,
  },
  {
    totalDuration,
    showShare: true,
  }
)

export const pageEndData = {
  key: "end",
  bgImg,
  Page: PageEnd,
}

PageEnd.displayName = "pageEnd"
export default PageEnd
